import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Swords, ArrowRight } from "lucide-react";

export default function CompetitorGap({ gap }) {
  const navigate = useNavigate();
  if (!gap?.gaps?.length) return null;
  return (
    <div className="card p-6 sm:p-7" data-testid="competitor-gap">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <span className="grid place-items-center w-7 h-7 rounded-lg" style={{ background: "rgba(217,92,92,.1)" }}><Swords size={15} strokeWidth={2} color="#C0455F" /></span>
          <span className="label-caps">Competitor gap</span>
        </div>
        <button className="text-sm font-semibold inline-flex items-center gap-1 hover:gap-1.5 transition-all text-ink" onClick={() => navigate("/app/competitors")} data-testid="competitor-gap-cta">
          See competitors <ArrowRight size={14} strokeWidth={2} />
        </button>
      </div>
      <p className="text-lg font-semibold text-ink mb-4">You're behind local leaders in <span style={{ color: "#C0455F" }}>{gap.behind_count} areas</span></p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {gap.gaps.map((g, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
            className="rounded-2xl p-4 border" style={{ borderColor: "#E7E8E4" }} data-testid={`gap-${i}`}>
            <div className="label-caps" style={{ color: "#C0455F" }}>{g.area}</div>
            <p className="text-sm text-ink-2 mt-1.5 leading-relaxed">{g.fact}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
